import { CollectionView } from "@newpla/wijmo";

export class NovaWijmoVinFilter {

    constructor(
        private readonly collectionView: CollectionView
    ) {
        this.collectionView.filters.push(this.vinFilter);
    }


    vinFilterText = '';
    private vinFilterSet = new Set<string>();
    private readonly vinFilter = (item: any): boolean => {
        if (this.vinFilterSet.size === 0) {
            return true;
        }
        const vin = this.normalizeVin(item.vin);
        return this.vinFilterSet.has(vin);
    };
    private normalizeVin(vin: unknown): string {
        return String(vin ?? '').trim().toUpperCase();
    }
    applyVinFilter(): void {
        const vins = this.vinFilterText
            .split(/[\s,;]+/)
            .map(vin => this.normalizeVin(vin))
            .filter(vin => vin.length > 0);

        this.vinFilterSet = new Set(vins);
        this.collectionView.refresh();
    }
    clearVinFilter(): void {
        this.vinFilterText = '';
        this.vinFilterSet.clear();
        this.collectionView.refresh();
    }

    destroy(): void {
        this.collectionView.filters.remove(this.vinFilter);
    }


    // ngOnDestroy(): void { this.vinFilter?.destroy(); }

}